// extracted by mini-css-extract-plugin
export default {"scaledContainer":"Pricing_scaledContainer__BqY+n","zoomBtn":"Pricing_zoomBtn__CE87Y"};